import React from 'react';
import clsx from 'clsx';

const BaseButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = (
  props,
) => {
  return (
    <button
      {...props}
      type={props.type ?? 'button'}
      className={clsx(
        'flex w-30 flex-row items-center gap-2 rounded-sm p-3',
        'justify-center text-center font-medium',
        'hover:bg-opacity-90 disabled:cursor-default disabled:opacity-50',
        props.className,
      )}
    />
  );
};

export default BaseButton;
